import Header from "components/Header";
import React from "react";
import {getAuth} from "firebase/auth";
import {useAuthState} from "react-firebase-hooks/auth";
import Loading from "components/Loading";
import {assertNoError} from "helpers/asserts";
import {isNullOrUndefined} from "helpers/is-null-or-undefined";
import ColorsDefinitionComponent from "./ColorsDefinitionComponent";

export function ColorsDefinitionPage() {
  const auth = getAuth();
  const [user, userLoading, userError] = useAuthState(auth);


  if (userLoading) {
    return <div className={"flex flex-col"}>
      <Loading className={"mt-24 text-xl"} loadingText={"Loading Colors ..."}/>
    </div>;
  }
  assertNoError(userError)

  if (
      isNullOrUndefined(user)
      || isNullOrUndefined(user.email)
      || !(
          user.email.endsWith("@kala.team")
          || user.email.endsWith("@brandingcompass.com")
      )
  ) {
    return <div className={"flex flex-col"}>
      You do not have permissions to access this page.
    </div>;
  }

  return <>
    <Header saveFormCallback={null} />
    <div className={"flex flex-col mb-24"}>
      <div>
        <ColorsDefinitionComponent/>
      </div>
    </div>
  </>;
}
